/** @format */

import React from 'react'

function SvgTop(props) {
  return (
    <svg height="512pt" viewBox="0 0 512 512" width="512pt" {...props}>
      <path
        d="M512 256c0 141.387-114.613 256-256 256S0 397.387 0 256 114.613 0 256 0s256 114.613 256 256zm0 0"
        fill="#80deea"
      />
      <path
        d="M0 256c0 141.152 114.848 256 256 256s256-114.848 256-256zm0 0"
        fill="#4dd0e1"
      />
      <g fill="#fff">
        <path d="M335.184 184.559L256 105.375l-79.184 79.184 22.625 22.625L240 166.625v121.137h32V166.625l40.559 40.559zm0 0M240 319.762h32v32h-32zm0 0M240 383.762h32v32h-32zm0 0" />
      </g>
    </svg>
  )
}

export default SvgTop
